// La hora de Asunción (guía, easter eggs 3.5): el sitio conoce la hora de Asunción, no
// la del visitante. Paraguay usa UTC−3 todo el año desde octubre de 2024; la zona
// America/Asuncion de los navegadores actuales ya lo refleja.

export const ASUNCION_TZ = "America/Asuncion";

export function asuncionTime(d: Date) {
  return new Intl.DateTimeFormat("es-PY", {
    timeZone: ASUNCION_TZ,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}

function parts(d: Date, opts: Intl.DateTimeFormatOptions) {
  const out: Partial<Record<Intl.DateTimeFormatPartTypes, string>> = {};
  for (const p of new Intl.DateTimeFormat("es-PY", { timeZone: ASUNCION_TZ, ...opts }).formatToParts(d)) out[p.type] = p.value;
  return out;
}

/** Hora de Asunción en horas decimales (23,5 = 23:30). La lee la escena (worldBus.hour). */
export function asuncionHour(d: Date): number {
  const p = parts(d, { hour: "numeric", minute: "numeric", hourCycle: "h23" });
  return (Number(p.hour) % 24) + Number(p.minute) / 60;
}

/**
 * Fecha y hora de Asunción como la escribe la terminal (02-EASTER-EGGS.md, 2):
 * "sábado 17 de octubre de 2026, 23:41 (America/Asuncion)". Se arma por partes porque
 * Intl pone una coma después del día de la semana.
 */
export function asuncionDateLine(d: Date): string {
  const p = parts(d, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return `${p.weekday} ${p.day} de ${p.month} de ${p.year}, ${asuncionTime(d)} (${ASUNCION_TZ})`;
}
